<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="edit-client-portal-dialog"
      :open.sync="openDialog"
      :form-ref.sync="clientPortalFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Modification du portail client</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-container>
          <v-text-field
            label="Passman ID"
            v-model="clientPortalForm.passmanId"
          ></v-text-field>
          <v-text-field
            label="Description"
            v-model="clientPortalForm.description"
          ></v-text-field>
          <v-autocomplete
            v-model="clientPortalForm.group"
            :items="groups.data"
            :search-input.sync="search"
            filled
            chips
            no-filter
            item-text="description"
            color="blue-grey lighten-2"
            label="Groupe:"
            item-value="id"
            hide-selected
            no-data-text="Pas de groupe correspondant à la recherche"
            persistent-hint
            hint="Vous pouvez sélectionner uniquement des GROUPES V5"
          >
            <template v-slot:selection="data">
              <v-chip v-bind="data.attrs" :input-value="data.selected">{{
                data.item.description
              }}</v-chip>
            </template>

            <template v-slot:item="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.description
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </template>
          </v-autocomplete>
          <v-checkbox
            v-model="clientPortalForm.isActive"
            label="Activer le client"
          ></v-checkbox>
          <v-checkbox
            v-model="clientPortalForm.useGroupCatalog"
            label="Utiliser le catalogue du groupe"
          ></v-checkbox>
          <v-checkbox
            v-model="clientPortalForm.isSandboxModeActive"
            label="Activer le mode sandbox"
          ></v-checkbox>
          <v-text-field
            v-model="clientPortalForm.cardPrefix"
            label="Préfixe des cartes"
          ></v-text-field>
          <v-checkbox
            v-model="clientPortalForm.hasMacLocking"
            label="Activer le blocage MAC"
          ></v-checkbox>
          <v-text-field
            v-model="clientPortalForm.proxyNumber"
            label="Nombres de serveur proxy"
          ></v-text-field>
        </v-container>
      </template>
      <template v-slot:[`dialog.actions.save`]>Enregistrer</template>
    </base-dialog>
  </div>
</template>
<script>
import { ref, toRefs, watch, onMounted, computed } from "@vue/composition-api";
import { useClientPortal } from "@/composables/client-portal";
import { useGroup } from "@/composables/group";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    BaseDialog,
  },
  props: {
    clientPortal: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { updateClientPortal, data } = useClientPortal();
    const { data: groupData, listGroups } = useGroup();

    /* Variables */
    const search = ref(null);

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Cycle de vie */
    onMounted(() => {
      data.clientPortalForm = Object.assign(
        data.clientPortalForm,
        props.clientPortal
      );

      if (props.clientPortal.group != null) {
        groupData.groups.data = [props.clientPortal.group];
      }
      if (props.clientPortal.group != null) {
        data.clientPortalForm.group = props.clientPortal.group.id;
      }
    });

    /* Méthodes */
    const saveItem = async function () {
      await updateClientPortal(props.clientPortal.id);
      openDialog.value = false;
    };

    /* Watchers */
    watch(
      () => search.value,
      function (newValue, oldValue) {
        if (newValue != oldValue && newValue.length >= 2) {
          listGroups(newValue);
        }
      }
    );

    return {
      dialogForEditClientPortal: ref(false),
      ...toRefs(data),
      ...toRefs(groupData),
      updateClientPortal,
      search,
      saveItem,
      openDialog,
    };
  },
};
</script>
